<template>
<div>
    <div class="bookitem">
        <div class="playimg">
            <div class="playicon" @click="$store.dispatch('bookplay',books.bookId)"></div>
        </div>
        <img class="faceimg" :src="books.faceImgPlay | objs" />
        <router-link :to="{path:'/bookdetail',query:{bookId:books.bookId}}"> 
            <p class="f18">
                <nobr>{{books.bookName}}</nobr>
            </p>
            <p class="f14">[{{books.nationName}}]{{books.author}}</p>
            <p class="f14">{{books.slogan}} </p>
            <p>
				<!-- <span class="ludubi">{{books.priceTag || '0.00'}}</span> -->
			<span class="f12">{{books.listenCount}}已听</span></p>
        </router-link>
    </div>

</div>
</template>

<script>
export default {
    name: 'BookItem',
    props: [
        "books"
    ]
}
</script>

<style scoped>
a {
    text-decoration: none;
}
.bookitem:hover .playimg{
    display: block !important;
}
.playimg {
    position: relative;
    z-index: 0;
    display: none;
}

.playimg .playicon {
    position: absolute;
    top: 50px;
    left: 50px;
    width: 60px;
    height: 60px;
    background-image: url(../assets/play.png);
    background-size:60px 60px;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    opacity: 1;
    z-index: 1;
}
.playimg .playicon:hover{opacity: 0.7;}

.xuhao {
    width: 50px;
    float: left;
}

.bookitem {
    width: 100%;
    float: left; 
    height: 160px;
    border: 1px;
    border-radius: 14px;
    background: #F9F9F9;
    margin: 10px 0;

}

.bookitem .faceimg {
    width: 160px;
    height: 160px;
    float: left;
    border: 1px;
    margin-right: 30px;
    background: rgba(210, 210, 210, 1);
    box-shadow: 1px 1px 10px 0px rgba(173, 195, 189, 0.43);
    border-radius: 2px; 
}

.bookitem .faceimg:hover {
    box-shadow: 1px 1px 10px 0px rgba(75, 204, 170, 0.5) !important;
}

.bookitem p {
    padding: 0;
    margin: 15px;
}

.f18 { 
    word-break: keep-all;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(36, 41, 38, 1);
}

.f14 {
    height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(155, 166, 166, 1);
}

.f12 {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(155, 166, 166, 1); 
}

.graybg {
    background: rgba(246, 247, 247, 1);
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(155, 166, 166, 1);
}

.graybg span {
    display: inline-block;
    padding: 2px 4px;
    background: rgba(75, 204, 170, 1);
    border-radius: 2px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    margin-right: 10px;
}

.ludubi {
    padding-right: 65px;
    margin-right: 15px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(155, 166, 166, 1);
    height: 22px;
    line-height: 18px;
    background-image: url(https://objs.auto-learning.com/xcximages/bi3x.png);
    background-position: right top;
    background-repeat: no-repeat;
    background-size: 65px 18px;
    display: inline-block;
}
</style>
